// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__36Oq5","footer":"ModalCreateQualiphyProcedure_footer__1csTo","additionData":"ModalCreateQualiphyProcedure_additionData__1Xgh_"};